module.exports = __webpack_public_path__ + "img/Bottone-Note-Generali.b8016375.jpg";